"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _themeUi = require("theme-ui");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ButtonLink = function ButtonLink(_ref) {
  var variant = _ref.variant,
      children = _ref.children,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      props = _objectWithoutPropertiesLoose(_ref, ["variant", "children", "disabled", "onClick"]);

  return (0, _themeUi.jsx)("button", _extends({}, props, {
    type: "button",
    disabled: disabled,
    onClick: disabled ? null : onClick,
    sx: _extends({}, variant ? {
      variant: "textStyles." + variant
    } : {
      fontSize: 'inherit',
      fontWeight: 'inherit',
      fontFamily: 'inherit',
      textTransform: 'inherit',
      lineHeight: 'inherit',
      letterSpacing: 'inherit'
    }, {
      display: 'inline',
      p: 0,
      bg: 'transparent',
      outline: 'none',
      borderStyle: 'none',
      cursor: 'pointer',
      pointerEvents: disabled ? 'none' : 'auto',
      textDecoration: 'underline',
      color: disabled ? 'textDisabled' : 'textMediumEmphasis',
      ':hover': {
        color: disabled ? 'textDisabled' : 'alerts.information'
      },
      ':active': {
        color: disabled ? 'textDisabled' : 'primaryDark'
      }
    })
  }), children);
};

ButtonLink.propTypes = {
  onClick: _propTypes["default"].func,
  disabled: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  variant: _propTypes["default"].oneOf(['heading1', 'heading2', 'heading3', 'heading4', 'heading5', 'heading6', 'body', 'subtitle', 'overline', 'caption', 'display', 'comic'])
};
var _default = ButtonLink;
exports["default"] = _default;